/* Product page redesign (pdp-v2) behaviours. Loaded only on the product template. */
(function () {
  'use strict';
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function () {
    var root = document.querySelector('.pdp-v2');
    if (!root) return;
    // ── Gallery: plain image switcher (no Swiper) ──
    // Show one main image at a time; clicking a thumbnail swaps it.
    var thumbs = root.querySelectorAll('.pdp-thumb');
    var mains = root.querySelectorAll('.pdp-main-img');
    function showSlide(i) {
      mains.forEach(function (m, idx) { m.classList.toggle('active', idx === i); });
      thumbs.forEach(function (t, idx) { t.classList.toggle('active', idx === i); });
    }
    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () { showSlide(idx); });
    });
    // Variant → image: the theme switched the slider when a variant has its own
    // featured image; mirror that in our (Swiper-free) gallery by id.
    function showImageById(imgId) {
      var target = root.querySelector('.pdp-main-img.id_' + imgId);
      if (!target) return;
      var i = Array.prototype.indexOf.call(mains, target);
      if (i >= 0) showSlide(i);
    }
    var idSelect = root.querySelector('select[name="id"]');
    function syncVariantImage() {
      if (!idSelect || !window.productJson || !window.productJson.variants) return;
      var v = window.productJson.variants.filter(function (x) { return String(x.id) === String(idSelect.value); })[0];
      if (v && v.featured_image && v.featured_image.id) showImageById(v.featured_image.id);
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.swatch-element')) setTimeout(syncVariantImage, 80);
    });
    root.addEventListener('change', function (e) {
      if (e.target && (e.target.classList.contains('single-option-selector') || e.target.name === 'id')) setTimeout(syncVariantImage, 80);
    });

    // ── Quantity stepper: own it ──
    // The theme binds TWO +/- handlers (theme-product.js direct + theme-common.js
    // document-level), so each click stepped by 2 and could reset to 1. Intercept
    // in the capture phase, block both, and do a clean ±1 (updating the cart only
    // when the item is already in it).
    var pform = root.querySelector('.product-form-wrap');
    if (pform) {
      var qInput = pform.querySelector('.quantity-box input[name="quantity"]');
      pform.querySelectorAll('.quantity-box .min, .quantity-box .plus').forEach(function (ctrl) {
        ctrl.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (!qInput) return;
          var v = parseInt(qInput.value, 10) || 1;
          v = ctrl.classList.contains('plus') ? v + 1 : Math.max(1, v - 1);
          qInput.value = v;
          // If the add-to-cart is hidden, the item is already in the cart — push
          // the new quantity to it.
          var atc = pform.querySelector('.add-to-cart');
          var inCart = atc && !atc.classList.contains('active');
          if (inCart) {
            var sel = pform.querySelector('select[name="id"]');
            var variantId = sel ? sel.value : null;
            if (variantId) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: v })
              }).then(function () {
                if (window.sideCart && typeof window.sideCart.updateCart === 'function') window.sideCart.updateCart();
              });
            }
          }
        }, true);
      });
    }
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function countUp(el){
      var target = parseFloat(el.getAttribute('data-target')); if (isNaN(target)) return;
      var dec = (target % 1 !== 0) ? 1 : 0;
      if (reduce){ el.textContent = target.toFixed(dec); return; }
      var start = null, dur = 950;
      function tick(t){ if(!start)start=t; var p=Math.min((t-start)/dur,1); var e=1-Math.pow(1-p,3); el.textContent=(target*e).toFixed(dec); if(p<1)requestAnimationFrame(tick); }
      requestAnimationFrame(tick);
    }
    function animateActiveMacros(){
      root.querySelectorAll('.metafields-data.active .pdp-macro .v').forEach(countUp);
    }
    animateActiveMacros();
    // Re-run the count-up when a variant switch toggles which macro set is active,
    // otherwise the newly-shown macros keep their placeholder "0".
    var macrosWrap = root.querySelector('.pdp-macros');
    if (macrosWrap && 'MutationObserver' in window) {
      var macroObserver = new MutationObserver(function (mutations) {
        var nowActive = mutations.some(function (m) {
          return m.target.classList
            && m.target.classList.contains('metafields-data')
            && m.target.classList.contains('active');
        });
        if (nowActive) animateActiveMacros();
      });
      macrosWrap.querySelectorAll('.metafields-data').forEach(function (el) {
        macroObserver.observe(el, { attributes: true, attributeFilter: ['class'] });
      });
    }
    (function reskinNutrition(){
      var raw = root.querySelector('.pdp-nutri-raw');
      if (!raw) return;
      if (raw.querySelector('#shredToggle')){ return; } // has its own working Standard/Large toggle — don't reskin, let it render as-is
      var table = raw.querySelector('table');
      if (!table){ return; } // leave raw visible — nothing to reskin
      // Build a clean card from the parsed table + allergen text.
      var card = document.createElement('div');
      card.className = 'pdp-nutri';
      var head = document.createElement('div');
      head.className = 'pdp-nutri-head';
      head.innerHTML = '<h3>Nutritional Info</h3>';
      card.appendChild(head);

      // Move the shred toggle (if present) into the head so it stays functional.
      var toggle = raw.querySelector('#shredToggle');
      var toggleWrap = toggle ? toggle.closest('label') : null;
      // If the toggle exists but we can't find its wrapper, don't reskin — hiding
      // the raw block would bury the toggle. Leave the original visible instead.
      if (toggle && !toggleWrap){ return; }
      if (toggleWrap){ head.appendChild(toggleWrap); toggleWrap.classList.add('pdp-shred-toggle'); }

      // Clean table: strip inline styles, tag sub-rows.
      var clean = table.cloneNode(true);
      clean.removeAttribute('style');
      clean.querySelectorAll('[style]').forEach(function(el){ el.removeAttribute('style'); });
      clean.classList.add('pdp-nt');
      clean.querySelectorAll('tbody tr').forEach(function(tr){
        var first = tr.querySelector('td');
        if (!first) return;
        var label = (first.textContent || '').trim().toLowerCase();
        if (label === 'saturated fat' || label === 'sugars'){ tr.classList.add('sub'); }
      });
      card.appendChild(clean);

      // Allergen line: the metafield often puts it in a trailing div after the table.
      var allergen = null;
      raw.querySelectorAll('div').forEach(function(d){
        if (/allergen/i.test(d.textContent || '') && !d.querySelector('table')) allergen = d;
      });
      if (allergen){
        var a = document.createElement('div'); a.className = 'pdp-allergen';
        a.innerHTML = allergen.innerHTML; a.querySelectorAll('[style]').forEach(function(el){el.removeAttribute('style');});
        card.appendChild(a);
      }

      raw.classList.add('pdp-nutri-raw--hidden');
      raw.parentNode.insertBefore(card, raw);
    })();
    // ── Task 9: Staggered entrance reveal ──
    if (!reduce){
      var details = root.querySelector('.product-details');
      if (details){
        Array.prototype.slice.call(details.children).forEach(function(el, i){
          el.classList.add('pdp-reveal');
          setTimeout(function(){ el.classList.add('in'); }, 60 * i);
        });
      }
    }
    // ── Task 10: Mobile sticky add-to-cart bar ──
    var mbar = document.querySelector('.pdp-mbar');
    // The add-to-cart button is a sibling of .product-form (inside .product-form-wrap),
    // not a descendant — query the wrap so the proxy actually finds it.
    var realBtn = root.querySelector('.product-form-wrap .add-to-cart');
    if (mbar && realBtn){
      mbar.querySelector('.pdp-mbar-btn').addEventListener('click', function(){ realBtn.click(); });
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          var show = !e.isIntersecting && window.innerWidth <= 900;
          mbar.classList.toggle('show', show);
          // Keep it out of the a11y tree while hidden, but announce it when it
          // becomes the visible add-to-cart on mobile.
          mbar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, {rootMargin:'0px 0px -20% 0px'});
      io.observe(realBtn);
    }
  });
})();
